import { useEffect } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

// const useStyles = makeStyles<Theme, { backgroundColor: string }>(() =>
//   createStyles({
//     bodyBackground: {
//       background: (props) => props.backgroundColor,
//     },
//   })
// );

export const useBodyBackgroundColor = (backgroundColor: string) => {
  useEffect(() => {
    document.body.style.background = backgroundColor;

    return () => {
      document.body.style.background = "";
    };
  }, [backgroundColor]);

  return null;
};
